import { Button, Col, Row, Slider, Typography, Drawer, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { ReactComponent as FlightIcon } from 'app/assets/img/icon_flight.svg';
import { ReactComponent as InfoIcon } from 'app/assets/img/iconInfo.svg';
import ContainerFluid from 'app/components/Layout/ContainerFluid';
import type { Ticket } from './components/type';
import useWindowSize from 'app/hooks/useWindowSize';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { formatAirport, formatNumber } from 'utils/helper';
import { useGlobalFunction } from '../App/hooks/useGlobalFunction';
import { selectTranslations, selectInfoUser } from '../App/slice/selectors';
import TooltipParagraph from '../Catalog/tooltipParagraph';
import FilterSearch from './FilterSearch';
import { HolidayListWrapper } from './styled';
import { useIdle } from './useIdle';
import { FlightChange } from '../FlightChange/Loadable';
import ItemCombo from './ItemCombo';
import { TicketList } from './components/TicketList';
import HeaderStep from './HeaderStep';
import useFetchData from 'app/hooks/useFetchData';
import { getConfirmPriceApi, getSearchComboApi } from 'app/services/holidayApi';
import {
  COMBO_HOLIDAY_TYPES,
  DEFAULT_FILTER_SEARCH,
  formatDate,
  IAirport,
  IFilterHolidaySearch,
  Stage,
} from '../BookingMask';
import {
  calculateHotelNights,
  isHotelCombo,
} from '../BookingMask/bookingMask.helpers';
import type { DrawerFHTFlightSummary } from './drawerOtherFHT.helpers';
import moment from 'moment';
import {
  saveSelectedTicket,
  getSelectedTickets,
  getSelectedFlights,
  getSearchParams,
  getComboSessionId,
  saveSelectedHotel,
  getSelectedHotels,
  clearSelectedTickets,
  clearSelectedHotels,
} from 'utils/sessionStorageHelper';
import type { SelectedTicket } from './types';
import { SESSION_KEYS } from './types';
import { useHolidaySession } from './hooks/useHolidaySession';
import LoadingComponent from './Loading';
import NoDataComponent from './NoData';
import { getCookie } from 'utils/cookies';
import {
  DEFAULT_LANGUAGE,
  TYPE_COOKIE,
  EXCHANGE_TICKETS_SELECTED,
} from 'utils/constants';
import _ from 'lodash';
import { LoadingContainer } from 'app/components/LoadingContainer';
import HolidayListFHT from './HolidayListFHT';
import DrawerOtherFHT from './DrawerOtherFHT';
import FilterOtherForFHT from './FilterOtherForFHT';
import useScrollIntoElement from 'utils/hooks/useScrollIntoElement';
const formatDuration = (duration: string) => {
  const h = Number(duration.slice(0, 2));
  const m = Number(duration.slice(2));

  if (h && m) return `${h}h${m}p`;
  if (h) return `${h}h`;
  return `${m}p`;
};
interface ComboItem {
  id: string;
  code: string;
  imageUrl: string | null;
  otaSiteCode: string;
  name: string;
  otaProductCode: string;
  languageCode: string | null;
  totalPrice?: number;
  paxPrice: number;
  additionalPrice: number;
  paxAdditionalPrice: number;
  multiple: number;
  minQuantity: number;
  combo_id: string;
  combo_code: string;
  combo_name: string;
  combo_description: string;
  combo_savingPercent: number;
}
interface ProductRaw {
  otaSiteName: string;
  description: string;
  [key: string]: ComboItem | string;
}
export const HolidayList: React.FC = () => {
  const locale = getCookie(TYPE_COOKIE.LANGUAGE) || DEFAULT_LANGUAGE;
  const { device } = useWindowSize();
  const isMobile = device === 'mobile';
  const translations = useSelector(selectTranslations);
  const userInfo: any = useSelector(selectInfoUser);
  const history = useHistory();
  const location = useLocation();
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const filterSearchRef = useRef<IFilterHolidaySearch>(DEFAULT_FILTER_SEARCH);
  const [priceRange, setPriceRange] = useState<[number, number]>([0, 1000]);
  const [isDrawerOtherFHT, setIsDrawerOtherFHT] = useState<boolean>(false);
  const [filterChangeHotel, setFilterChangeHotel] = useState<unknown>(null);
  const [isAllVisible, setIsAllVisible] = useState<boolean>(true);
  const [searchAirports, setSearchAirports] = useState<{
    departure?: IAirport;
    destination?: IAirport;
  }>({});
  const debounceRef = useRef<any>(null);
  const comboAnchorRef = useRef<HTMLDivElement>(null);
  // Use holiday session hook for session storage management
  const holidaySession = useHolidaySession();
  const onChangePriceRange = val => {
    filterSearchRef.current = {
      ...filterSearchRef.current,
      minPrice: val?.[0],
      maxPrice: val?.[1],
    };
    const searchParams = new URLSearchParams(location.search);
    if (val?.[0] !== undefined) {
      searchParams.set('minPrice', val[0]);
    } else {
      searchParams.delete('minPrice');
    }
    if (val?.[1] !== undefined) {
      searchParams.set('maxPrice', val[1]);
    } else {
      searchParams.delete('maxPrice');
    }
    history.replace(`/holiday?${searchParams.toString()}`);
  };
  const [dataHolidayList, setDataHolidayList] = useState<any>([]);
  const [flightInfo, setFlightInfo] = useState<any>({});

  // Refresh placeholder while holiday list reloads after change
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { onScrollIntoElement: onScrollIntoElementCombo } =
    useScrollIntoElement({
      elementRef: comboAnchorRef,
    });
  const onChangeOptionHotel = val => {
    const ratings = val?.ratings || [];
    const amenities = val?.amenities || [];
    filterSearchRef.current = {
      ...filterSearchRef.current,
      ratings,
      amenities,
    };
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      const searchParams = new URLSearchParams(location.search);
      if (!_.isEmpty(ratings)) {
        searchParams.set('ratings', ratings.join(','));
      } else {
        searchParams.delete('ratings');
      }
      if (!_.isEmpty(amenities)) {
        searchParams.set('amenities', amenities.join(','));
      } else {
        searchParams.delete('amenities');
      }
      history.replace(`/holiday?${searchParams.toString()}`);
    }, 500);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const ensureHistoryStack = () => {
      const state = window.history.state;
      if (!state || !state.__fromApp) {
        window.history.replaceState(
          { __fromApp: true },
          '',
          window.location.href,
        );
        window.history.pushState({ __fromApp: true }, '', window.location.href);
      }
    };
    ensureHistoryStack();
    const handlePopState = () => {
      window.history.pushState({ __fromApp: true }, '', window.location.href);
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: translations?.['b2b.txt.confirmLeavePage'],
        content: translations?.['b2b.txt.leavePageWarning'],
        buttons: [
          {
            text: translations?.['b2c.btn.cancel'] ?? '',
            bg: '#ffff',
            border: 'solid 1px #808080',
            color: '#808080',
            onClick: () => {
              onCloseDialogNoti();
            },
          },
          {
            text: translations?.['b2c.txt.confirm'] ?? '',
            bg: 'var(--color-gradient)',
            color: 'white',
            onClick: () => {
              onCloseDialogNoti();
              window.removeEventListener('popstate', handlePopState);
              history.push('/home');
            },
          },
        ],
        maskClosable: false,
        onCloseDialog: onCloseDialogNoti,
      });
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [history, onOpenDialogNoti, onCloseDialogNoti, translations]);
  const { resetIdle } = useIdle(5 * 60 * 1000, () => {
    setIsAllVisible(true);
    //5 phút
    onOpenDialogNoti({
      type: 'ERROR',
      isShow: true,
      title: translations?.['b2b.txt.searchResultChanged'],
      content: translations?.['b2b.txt.priceAndAvailabilityUpdated'],
      buttons: [
        {
          text: translations?.['b2b.txt.later'] ?? '',
          bg: '#ffff',
          border: 'solid 1px #808080',
          color: '#808080',
          onClick: () => {
            onCloseDialogNoti();
            resetIdle();
          },
        },
        {
          text: translations?.['b2b.txt.reloadResults'] ?? '',
          bg: 'var(--color-gradient)',
          color: 'white',
          onClick: () => {
            setDrawerVisible(false);
            setFlightDrawerVisible(false);
            setIsDrawerOtherFHT(false);
            setIsAllVisible(false);
            onFetchDataInit(filterSearchRef.current);
            onCloseDialogNoti();
            resetIdle();
          },
        },
      ],
      maskClosable: false,
      onCloseDialog: onCloseDialogNoti,
    });
  });
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setPriceRange([
      Number(params.get('minPrice') ?? 0) / 20000,
      Number(params.get('maxPrice') ?? 1000 * 20000) / 20000,
    ]);
  }, [location.search]);
  type InputData = Record<string, ProductRaw>;
  const convertData = (data: InputData) => {
    const result = Object.entries(data).map(([productCode, value]) => {
      const { otaSiteName, description, ...rest } = value;
      const combo: ComboItem[] = Object.entries(rest)
        .filter(([key]) => !isNaN(Number(key)))
        .map(([, val]) => val as ComboItem)
        .filter(item => item && typeof item === 'object')
        .sort(
          (a, b) => (a.totalPrice ?? Infinity) - (b.totalPrice ?? Infinity),
        );
      const minPrice =
        combo.length > 0 ? combo[0].totalPrice ?? Infinity : Infinity;
      return {
        productCode,
        productName: otaSiteName ?? '',
        description: description ?? '',
        combo,
        minPrice,
      };
    });
    return result.sort((a, b) => a.minPrice - b.minPrice);
  };
  const { onFetchData: onFetchSearchCombo } = useFetchData({
    actionApi: getSearchComboApi,
    IIFE: false,
    onBefore: () => {
      setIsRefreshing(true);
      holidaySession.clearSessionForNewSearch();
    },
    onSuccess: response => {
      const comboType = response?.comboType || response?.data?.comboType || '';
      const combo = response?.combo || response?.data?.combo || {};
      const resComboTicker = isHotelCombo(comboType)
        ? combo.hotels || []
        : convertData(combo?.tickets || {});
      setDataHolidayList(resComboTicker);
      setIsRefreshing(false);
      setFlightInfo(combo?.flight);

      // Handle session storage via hook
      holidaySession.handleComboSuccess(response);
      onScrollIntoElementCombo();
    },
    onError: () => {
      setIsRefreshing(false);
      setDataHolidayList([]);
      setFlightInfo({});
    },
    onFinally: () => {
      setIsRefreshing(false);
    },
  });
  const onFetchDataInit = (data: IFilterHolidaySearch) => {
    const isComboFHT =
      data.comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET ||
      data.comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL;
    const params = {
      search: {
        comboType: data.comboType,
        departure: data?.departure,
        arrival: data?.destination,
        departureDate: data?.departureDate,
        ...(data?.stage === 'round-trip' && {
          arrivalDate: data?.returnDate,
        }),
        adults: data?.adult || 1,
        children: data?.child || 0,
        infants: data?.infant || 0,
        rooms: isComboFHT ? data?.room || 1 : data?.adult || 1,
        currency: 'VND',
        isRoundTrip: !!(data?.stage === 'round-trip'),
        isIncludedHotel: isComboFHT ? true : false,
        isIncludedTicket: true,
        ...(isComboFHT && {
          checkin: data.checkin,
          checkout: data.checkout,
        }),
      },
      filters: {
        priceRange: {
          min: data?.minPrice ?? 0,
          max: data?.maxPrice ?? 20000000,
        },
        ...(isComboFHT && {
          hotelStarGroups: data?.ratings?.join(','),
          amenityCodes: data?.amenities || [],
        }),
      },
    };
    // Save search params via hook
    holidaySession.handleSaveSearchParams(params);

    onFetchSearchCombo({ payloadData: params });
  };

  // Drawer state for viewing additional combo options
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerTickets, setDrawerTickets] = useState<Ticket[]>([]);
  const [drawerTitle, setDrawerTitle] = useState('');

  // Use session management from hook
  const {
    selectedTicketsMap,
    setSelectedTicketsMap,
    selectedFlight,
    setSelectedFlight,
    flightRefreshKey,
    setFlightRefreshKey,
  } = holidaySession;

  const [displayFlights, setDisplayFlights] = useState<any[]>([]); // Cached display flights

  // Flight-change drawer state
  const [flightDrawerVisible, setFlightDrawerVisible] = useState(false);
  const [flightDrawerSearch, setFlightDrawerSearch] = useState<string>('');
  const [flightDrawerKey, setFlightDrawerKey] = useState(0); // Force remount FlightChange
  const [flightTargetItemId, setFlightTargetItemId] = useState<number | null>(
    null,
  );
  const [selectedDeltas, setSelectedDeltas] = useState<Record<number, number>>(
    {},
  );

  const [lastComboOpenedItemId, setLastComboOpenedItemId] = useState<
    number | null
  >(null);

  // Header node coming from FlightChange when rendered inside Drawer
  const [flightDrawerTitleNode, setFlightDrawerTitleNode] =
    useState<React.ReactNode>(null);

  // Load selected tickets from session storage
  useEffect(() => {
    const savedTickets = getSelectedTickets();
    const ticketsMap: Record<string, SelectedTicket> = {};
    savedTickets.forEach(ticket => {
      if (ticket.productCode) {
        ticketsMap[ticket.productCode] = ticket;
      }
    });
    setSelectedTicketsMap(ticketsMap);

    // Load selected flights from session storage (both outbound and return)
    const savedFlights = getSelectedFlights();
    // selectedFlight will be used for display - keep first flight for backward compat
    if (savedFlights.length > 0) {
      setSelectedFlight(savedFlights[0]);
    }
  }, [setSelectedTicketsMap, setSelectedFlight]);

  // Helper function to get cheapest trip for a route
  const getCheapestTrip = (listTrip: any[]) => {
    if (!listTrip || listTrip.length === 0) return null;

    return listTrip.reduce((cheapest, trip) => {
      const tripPrice = Math.min(
        ...(trip.listPricing?.map(p => p.additionalAmount || 0) || [0]),
      );
      const cheapestPrice = Math.min(
        ...(cheapest.listPricing?.map(p => p.additionalAmount || 0) || [
          Infinity,
        ]),
      );

      return tripPrice < cheapestPrice ? trip : cheapest;
    });
  };

  // Get flights to display on main screen (only outbound + return, selected or cheapest)
  const getDisplayFlights = () => {
    if (!flightInfo?.listFlight) return [];

    const result: any[] = [];
    const savedFlights = getSelectedFlights();

    flightInfo.listFlight.forEach((route, routeIndex) => {
      // Check if user has selected a flight for this route
      const selectedForRoute = savedFlights.find(
        sf => sf.route && sf.route.route === route.route,
      );

      if (selectedForRoute && selectedForRoute.trip) {
        // Use selected trip with all its data (including updated booking class)
        result.push({
          ...route,
          listTrip: [selectedForRoute.trip],
          _isSelected: true,
        });
      } else {
        // Use cheapest trip
        const cheapest = getCheapestTrip(route.listTrip);
        if (cheapest) {
          result.push({
            ...route,
            listTrip: [cheapest],
            _isSelected: false,
          });
        }
      }
    });

    return result;
  };

  // Update displayFlights when flightInfo or flightRefreshKey changes
  useEffect(() => {
    const flights = getDisplayFlights();
    setDisplayFlights(flights);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flightInfo, flightRefreshKey]);

  // Helper to get combo to display for an item (selected or default first)
  const getDisplayCombo = (item: any) => {
    if (!item?.combo || item.combo.length === 0) return null;

    // Check if user has selected a ticket for this product
    const selectedTicket = selectedTicketsMap[item.code];
    if (selectedTicket && selectedTicket.ticket) {
      // Find matching combo by ID
      const matchingCombo = item.combo.find(
        (c: any) => c.id === selectedTicket.ticket.id,
      );
      if (matchingCombo) {
        return matchingCombo;
      }
    }

    // Default to first combo
    return item.combo[0];
  };

  const openDrawerWithCombos = (
    combos: any[],
    title: string,
    price?: number,
    itemId?: number,
  ) => {
    // Map combo tickets from API structure to UI Ticket format
    const mappedTickets: Ticket[] = (combos || []).map((c: any) => ({
      id: c.id,
      title: c.name || c.combo_name || '',
      combo_description: c.combo_description || c.comboDescription || '',
      description: (c.combo_description ||
        c.comboDescription ||
        c.description ||
        '') as string,
      image: c.imageUrl || c.image || '',
      tags: [],
      // Prefer paxPrice when available, fallback to totalPrice or generic price
      paxPrice: c.paxPrice ?? c.totalPrice ?? c.price ?? 0,
      price: c.paxPrice ?? c.totalPrice ?? c.price ?? 0,
      combo_id: c.combo_id,
      _rawTicket: c,
    }));

    setDrawerTickets(mappedTickets);
    setDrawerTitle(title || '');
    setLastComboOpenedItemId(itemId ?? null);
    setDrawerVisible(true);
  };

  // Handler when user chooses in TicketList drawer: persist, notify, call API, then update UI
  const handleTicketSelect = async (
    ticket: Ticket,
    siteCode: string,
    siteName: string,
    productCode: string,
  ) => {
    // If offline, reuse PassengerInfo offline dialog and do not proceed
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      try {
        sessionStorage.setItem('SKIP_OFFLINE_DIALOG', '1');
      } catch (e) {}

      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: translations?.['b2c.action.failed'] ?? 'Thao tác thất bại',
        content:
          translations?.['b2c.message.tryNetwork'] ||
          'Đã có lỗi xảy ra. Quý khách vui lòng thao tác lại.',
        closable: true,
        maskClosable: true,
        onCloseDialog: () => {
          try {
            sessionStorage.removeItem('SKIP_OFFLINE_DIALOG');
          } catch (e) {}
          onCloseDialogNoti();
        },
        buttons: [
          {
            text: translations?.['b2c.btn.retry'] || 'Thử lại',
            bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
            color: 'white',
            onClick: () => {
              try {
                sessionStorage.removeItem('SKIP_OFFLINE_DIALOG');
              } catch (e) {}
              onCloseDialogNoti();
            },
          },
        ],
      });

      return;
    }

    // Extract combo_id from ticket and wrap as array
    const comboId = ticket._rawTicket?.combo_id || (ticket as any).combo_id;
    const comboCode =
      ticket._rawTicket?.combo_code || (ticket as any).combo_code;
    const comboIds = comboId ? [comboId] : [];
    // Get combo name from ticket (prefer combo_name, fall back to other fields or the drawer title)
    const comboName =
      ticket._rawTicket?.combo_name ||
      ticket.combo_name ||
      ticket._rawTicket?.name ||
      (ticket as any).name ||
      siteName ||
      ticket.title;

    // Save to session storage using new helper
    const ticketData: SelectedTicket = {
      ticket: ticket._rawTicket
        ? {
            ...ticket._rawTicket,
            comboIds: comboIds,
            comboCode: comboCode,
            // ensure otaSiteName exists on the stored ticket for downstream consumers
            otaSiteName: comboName,
          }
        : {
            id: ticket.id,
            code: ticket.id,
            imageUrl: ticket.image,
            otaSiteCode: siteCode,
            otaSiteName: comboName,
            otaProductCode: productCode,
            languageCode: null,
            totalPrice: ticket.paxPrice ?? ticket.price,
            paxPrice: ticket.paxPrice ?? ticket.price,
            additionalPrice: 0,
            paxAdditionalPrice: 0,
            multiple: 1,
            minQuantity: 1,
            comboIds: comboIds,
            comboCode: comboCode,
          },
      siteCode,
      siteName: comboName,
      productCode,
      quantity: 1,
      selectedAt: new Date().toISOString(),
    };

    saveSelectedTicket(ticketData);
    const paramsConfirm = convertParamToConfirmPrice();
    onFetchConfirmPrice({ payloadData: paramsConfirm });
  };
  const itinerary =
    flightInfo?.listFlight?.[0]?.listTrip?.[0]?.listItinerary?.[0] ?? {};
  const departure = itinerary?.departureInfo;
  const arrival = itinerary?.arrivalInfo;

  // Tạo title cho flight drawer
  const flightDrawerTitle = useMemo(() => {
    if (departure && arrival) {
      const departureText = formatAirport(departure);
      const arrivalText = formatAirport(arrival);
      return `${departureText} - ${arrivalText}`;
    }
    return (
      translations?.['b2b.txt.flightSearchDrawerTitle'] ?? 'Tìm chuyến bay'
    );
  }, [departure, arrival, translations]);
  const onClickPolicy = () => {
    const region = 'vn';
    const urlPolicy = `https://www.sunphuquocairways.com/${region}/${locale}/spa-holidays/terms-and-conditions`;
    window.open(urlPolicy, '_blank');
  };
  const { onFetchData: onFetchConfirmPrice, isLoading: isLoadingConfirmPrice } =
    useFetchData({
      actionApi: getConfirmPriceApi,
      IIFE: false,
      onSuccess: response => {
        saveTicketWhenConfirmPriceSuccess(response);
      },
    });
  const saveTicketWhenConfirmPriceSuccess = (response: any) => {
    const existingTickets = getSelectedTickets() || [];
    for (let i = 0; i < existingTickets.length; i++) {
      const ticket = existingTickets?.[i];
      const orig = ticket.ticket as any;
      const normalized: any = {
        ...orig,
        totalPrice: response.totalAmount || orig.totalPrice,
        paxPrice: response.paxAmount || orig.paxPrice,
        commission: response.percentageCombo || 0,
        discount: response.discountCombo || 0,
        totalPayment: response.totalPayment || 0,
      };
      const ticketFinal = {
        ...ticket,
        ticket: normalized,
      };
      saveSelectedTicket(ticketFinal);
    }
    if (drawerVisible) {
      // Refresh selected tickets map from session storage
      const savedTickets = getSelectedTickets();
      const ticketsMap: Record<string, SelectedTicket> = {};
      savedTickets.forEach(t => {
        if (t.productCode) {
          ticketsMap[t.productCode] = t;
        }
      });
      setSelectedTicketsMap(ticketsMap);
      setDrawerVisible(false);
    }
    goToPassengerInfo();
  };
  const goToPassengerInfo = () => {
    const searchParams = new URLSearchParams(location.search);
    const baseParams = {
      adults: searchParams.get('adult') ?? '1',
      children: searchParams.get('child') ?? '0',
      infants: searchParams.get('infant') ?? '0',
      tripType: searchParams.get('stage') ?? 'one-way',
    };
    const isFlightHotelCombo =
      filterSearchRef.current.comboType ===
        COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET ||
      filterSearchRef.current.comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL;
    const queryParams = new URLSearchParams({
      ...baseParams,
      ...(isFlightHotelCombo && {
        comboType:
          searchParams.get('comboType') ?? COMBO_HOLIDAY_TYPES.FLIGHT_TICKET,
        checkin: searchParams.get('checkin') ?? '',
        checkout: searchParams.get('checkout') ?? '',
        room: searchParams.get('room') ?? '1',
      }),
    });
    history.push(`/holiday/passenger-info?${queryParams.toString()}`);
  };
  const handleComboSelect = (displayCombo, item) => {
    // Get passenger counts from URL params
    const searchParams = new URLSearchParams(location.search);
    const adults = searchParams.get('adult') || '1';
    const children = searchParams.get('child') || '0';
    // Save selected flights to session storage (no action required here)
    // Save combo ticket to session storage if it has ticket data
    if (displayCombo && item) {
      // Extract combo_id from displayCombo and wrap as array
      const comboId =
        displayCombo._rawTicket?.combo_id ||
        displayCombo.combo_id ||
        (displayCombo as any).combo_id;
      const comboCode =
        displayCombo._rawTicket?.combo_code ||
        displayCombo.combo_code ||
        (displayCombo as any).combo_code;
      const comboIds = comboId ? [comboId] : [];
      // Get combo name (name is the actual combo title)
      const comboName =
        displayCombo._rawTicket?.name ||
        displayCombo._rawTicket?.combo_name ||
        displayCombo.combo_name ||
        displayCombo.name ||
        (displayCombo as any).name ||
        displayCombo.title ||
        item.productName;
      // Check if combo has ticket information
      const comboTicket = displayCombo._rawTicket
        ? {
            ...displayCombo._rawTicket,
            comboIds: comboIds,
            comboCode: comboCode,
            otaSiteName:
              displayCombo._rawTicket?.combo_name ||
              displayCombo._rawTicket?.name ||
              displayCombo.name ||
              item.productName,
          }
        : {
            id: displayCombo.id || item.code,
            code: item.code,
            imageUrl: displayCombo.imageUrl || null,
            otaSiteCode: item.code,
            otaSiteName:
              displayCombo.combo_name || displayCombo.productName || item.name,
            otaProductCode: displayCombo.name || item.productName,
            languageCode: null,
            totalPrice:
              (displayCombo.totalPrice ?? displayCombo.paxPrice) ||
              displayCombo.price ||
              0,
            paxPrice:
              (displayCombo.paxPrice ?? displayCombo.totalPrice) ||
              displayCombo.price ||
              0,
            additionalPrice: 0,
            paxAdditionalPrice: 0,
            multiple: 1,
            minQuantity: 1,
            comboIds: comboIds,
            comboCode: comboCode,
          };
      const ticketData: SelectedTicket = {
        ticket: comboTicket,
        siteCode: item.code,
        siteName: comboName,
        productCode: displayCombo.name || item.productName,
        quantity: parseInt(adults) + parseInt(children),
        selectedAt: new Date().toISOString(),
      };
      saveSelectedTicket(ticketData);
      if (userInfo?.id) {
        sessionStorage.setItem(SESSION_KEYS.SESSION_USER, String(userInfo.id));
      }
    }
    const paramsConfirm = convertParamToConfirmPrice();
    onFetchConfirmPrice({ payloadData: paramsConfirm });
  };
  const onSelectComboFHT = hotel => {
    clearSelectedTickets();
    clearSelectedHotels();
    const searchParams = new URLSearchParams(location.search);
    const adults = searchParams.get('adult') || '1';
    const children = searchParams.get('child') || '0';
    const isFH =
      filterSearchRef.current?.comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL;
    const firstRoom = hotel?.roomTypes?.[0];
    const pricing = firstRoom?.pricing;
    const tickets = isFH ? [{ comboCode: '' }] : pricing?.tickets || [];
    const ticketsToSave =
      pricing?.isIncludeAllTicket === true ? tickets : tickets.slice(0, 1);
    const comboId = pricing.comboId;
    const comboCode = pricing.comboCode;
    const comboIds = comboId ? [comboId] : [];
    const comboName = pricing.comboName;
    const selectedAt = new Date().toISOString();
    for (let i = 0; i < ticketsToSave.length; i++) {
      const item = ticketsToSave[i];
      const comboTicket = {
        id: item.id,
        code: item.code,
        imageUrl: item?.media?.[0] || item.imageUrl || null,
        otaSiteCode: item.code,
        otaSiteName: item.otaSiteName,
        otaProductCode: item.name,
        languageCode: null,
        totalPrice: pricing.totalPrice || 0,
        paxPrice: pricing.paxPrice || 0,
        additionalPrice: item.additionalAmount || 0,
        paxAdditionalPrice: item.paxAdditionalAmount || 0,
        multiple: 1,
        minQuantity: 1,
        comboIds: comboIds,
        comboCode: comboCode,
      };
      const ticketData: SelectedTicket = {
        ticket: comboTicket,
        siteCode: item.code,
        siteName: comboName,
        productCode: item.name,
        quantity: parseInt(adults) + parseInt(children),
        selectedAt,
        isIncludeAllTicket: pricing.isIncludeAllTicket,
        comboType: filterSearchRef.current.comboType,
      };
      saveSelectedTicket(ticketData);
    }
    saveSelectedHotel(hotel);
    if (userInfo?.id) {
      sessionStorage.setItem(SESSION_KEYS.SESSION_USER, String(userInfo.id));
    }
    const paramsConfirm = convertParamToConfirmPrice();
    onFetchConfirmPrice({ payloadData: paramsConfirm });
  };

  const drawerFlightSummary = useMemo((): DrawerFHTFlightSummary => {
    const params = new URLSearchParams(location.search);
    const departure = params.get('departure') || '';
    const destination = params.get('destination') || '';
    const stage = (params.get('stage') as Stage) || 'round-trip';
    const checkin = params.get('checkin') || '';
    const checkout = params.get('checkout') || '';
    const checkinDate = checkin
      ? formatDate(moment(checkin), translations)
      : '';
    const checkoutDate = checkout
      ? formatDate(moment(checkout), translations)
      : '';

    return {
      departureAirport: searchAirports.departure,
      destinationAirport: searchAirports.destination,
      routeLabel:
        departure && destination ? `${departure} → ${destination}` : '',
      stage,
      dateLabel:
        checkinDate && checkoutDate ? `${checkinDate} → ${checkoutDate}` : '',
      nights: calculateHotelNights(checkin, checkout),
    };
  }, [location.search, translations, searchAirports]);

  const onSelectOtherPackage = item => {
    const hotelId = item?.hotel?.id || item?.hotelId || item?.id;
    const filterHotel = {
      sessionId: getComboSessionId(),
      hotelId,
      filters: {
        priceRange: {
          min: filterSearchRef.current?.minPrice ?? 0,
          max: filterSearchRef.current?.maxPrice ?? 20000000,
        },
        hotelStarGroups: filterSearchRef.current?.ratings?.join(','),
        amenityCodes: filterSearchRef.current?.amenities || [],
      },
    };
    setFilterChangeHotel(filterHotel);
    setIsDrawerOtherFHT(true);
  };

  const convertParamToConfirmPrice = () => {
    const tickets = getSelectedTickets();
    const flights = getSelectedFlights();
    const hotels = getSelectedHotels();
    const isIncludeAllTicket = tickets?.[0]?.isIncludeAllTicket ? 1 : 0;
    const comboType =
      tickets?.[0]?.comboType ||
      filterSearchRef.current?.comboType ||
      COMBO_HOLIDAY_TYPES.FLIGHT_TICKET;
    const dataCombo = tickets?.[0]?.ticket;
    const ticketIds = tickets?.map(({ ticket }) => ticket?.id).filter(Boolean);
    const listItinerary = flights.map((item, index) => {
      return {
        route: item?.route?.route || '',
        tripId: item?.trip?.tripId || '',
        bookingClass: item?.pricing?.bookingClass || '',
      };
    });
    const hotel = {
      isIncludeAllTicket,
      comboType,
      arrivalDate: filterSearchRef.current.checkin,
      lengthOfStay: filterSearchRef.current.hotelNights,
      hotelId: hotels?.[0]?.hotel.id,
      roomTypeId: hotels?.[0]?.roomTypes?.[0]?.roomType?.id,
      ratePlanId: hotels?.[0]?.roomTypes?.[0]?.pricing?.ratePlanId,
      roomOccupancy: {
        numberOfAdult: filterSearchRef.current.adult,
        numberOfChild: filterSearchRef.current.child,
        numberOfInfant: filterSearchRef.current.infant,
        numberOfRoom: filterSearchRef.current.room,
      },
    };
    const params = {
      comboId: dataCombo?.comboIds?.[0] || '',
      comboCode: dataCombo?.comboCode || '',
      comboType,
      isIncludeAllTicket,
      // ticketId: dataCombo.id,
      ticketIds,
      flight: {
        listItinerary: listItinerary,
        dataSessionId: JSON.parse(
          sessionStorage.getItem(SESSION_KEYS.COMBO_SESSION_ID) as string,
        ),
      },
      ...((filterSearchRef.current.comboType ===
        COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET ||
        filterSearchRef.current.comboType ===
          COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL) && {
        hotel,
      }),
    };
    return params;
  };
  const onCloseDrawerOtherFHT = () => {
    setIsDrawerOtherFHT(false);
  };

  const onSelectComboFromDrawer = (payload: { hotel: any; roomOffer: any }) => {
    setIsDrawerOtherFHT(false);
    const hotelPayload = {
      hotel: payload.hotel?.hotel,
      roomTypes: [payload.roomOffer],
      media: payload.hotel?.media,
    };
    onSelectComboFHT(hotelPayload);
  };

  return (
    <LoadingContainer loading={isLoadingConfirmPrice}>
      <HeaderStep />
      <ContainerFluid>
        <HolidayListWrapper>
          <FilterSearch
            filterSearchRef={filterSearchRef}
            onFetchDataInit={onFetchDataInit}
            isRefreshing={isRefreshing}
            onAirportsChange={setSearchAirports}
          />
          <div ref={comboAnchorRef} />
          <Col span={24}>
            <Row gutter={device === 'desktop' ? 24 : 0}>
              {device === 'desktop' && (
                <Col span={6}>
                  <div className="view-left">
                    <div className="view-total">
                      <div className="header-filter">
                        {translations?.['b2b.txt.priceRange']}
                      </div>
                      <TooltipParagraph className="description-price">
                        {translations?.['b2b.txt.b2b.txt.pricePerPassenger']}
                      </TooltipParagraph>
                      <div className="boxPriceRange mb-3">
                        <SliderWrapper
                          tooltipVisible={false}
                          step={2}
                          min={0}
                          max={1000}
                          range
                          value={priceRange}
                          onChange={val => {
                            setPriceRange(val);
                          }}
                          onAfterChange={val => {
                            onChangePriceRange(val.map(i => i * 20000));
                          }}
                        />
                        <div className="d-flex justify-content-between">
                          <span style={{ fontSize: 12 }}>
                            {translations?.['b2b.txt.b2b.txt.from']}
                          </span>
                          <span style={{ fontSize: 12 }}>
                            {translations?.['b2b.txt.b2b.txt.to']}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="textPriceRange">{`${formatNumber(
                            priceRange[0] * 20000,
                            '.',
                          )}đ`}</span>
                          <span className="textPriceRange">{`${formatNumber(
                            priceRange[1] * 20000,
                            '.',
                          )}đ`}</span>
                        </div>
                      </div>
                    </div>
                    {(filterSearchRef.current.comboType ===
                      COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET ||
                      filterSearchRef.current.comboType ===
                        COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL) && (
                      <FilterOtherForFHT onChange={onChangeOptionHotel} />
                    )}
                  </div>
                </Col>
              )}
              <Col span={device === 'desktop' ? 18 : 24}>
                {/* block header */}
                {isRefreshing ? (
                  <LoadingComponent />
                ) : (
                  <>
                    <Title>{translations?.['b2b.txt.flightInformation']}</Title>
                    <div className="view-right-info">
                      {_.isEmpty(flightInfo?.listFlight) ? (
                        <NoDataComponent />
                      ) : (
                        <>
                          <div
                            className="d-flex border-bottom align-items-center"
                            style={{
                              paddingLeft: 14,
                              paddingTop: 6,
                              paddingBottom: 0,
                            }}
                          >
                            <div className="" style={{ marginRight: 'auto' }}>
                              <Typography className="text-flight">
                                {selectedFlight ? (
                                  // Hiển thị selected flight
                                  <>
                                    {formatAirport(
                                      selectedFlight.route.listTrip[0]
                                        ?.listItinerary[0]?.departureInfo,
                                    )}{' '}
                                    <i
                                      className={`fa-solid ${
                                        flightInfo?.listFlight?.length > 1
                                          ? 'fa-arrow-right-arrow-left'
                                          : 'fa-arrow-right'
                                      }`}
                                      style={{ fontSize: 12 }}
                                    />{' '}
                                    {formatAirport(
                                      selectedFlight.route.listTrip[0]
                                        ?.listItinerary[0]?.arrivalInfo,
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {formatAirport(departure)}{' '}
                                    <i
                                      className={`fa-solid ${
                                        flightInfo?.listFlight?.length > 1
                                          ? 'fa-arrow-right-arrow-left'
                                          : 'fa-arrow-right'
                                      }`}
                                      style={{ fontSize: 12 }}
                                    />{' '}
                                    {formatAirport(arrival)}
                                  </>
                                )}
                              </Typography>
                              <Typography className="text-time-flight">
                                {selectedFlight ? (
                                  // Hiển thị date của selected flight
                                  <>
                                    {formatDate(
                                      moment(
                                        selectedFlight.route.listTrip[0]
                                          ?.listItinerary[0]?.departureInfo
                                          ?.datetime,
                                      ),
                                      translations,
                                    )}
                                    {/* For round-trip, show both departure dates */}
                                    {flightInfo?.listFlight?.length > 1 &&
                                      (() => {
                                        // Get all selected flights to find return flight
                                        const allSelectedFlights =
                                          getSelectedFlights();
                                        const returnFlight =
                                          allSelectedFlights.find(
                                            sf =>
                                              sf.route?.route !==
                                              selectedFlight.route?.route,
                                          );

                                        if (returnFlight) {
                                          return (
                                            <>
                                              {' - '}
                                              {formatDate(
                                                moment(
                                                  returnFlight.route.listTrip[0]
                                                    ?.listItinerary[0]
                                                    ?.departureInfo?.datetime,
                                                ),
                                                translations,
                                              )}
                                            </>
                                          );
                                        }
                                        // Fallback: use original flightInfo if no return flight selected
                                        return (
                                          <>
                                            {' - '}
                                            {formatDate(
                                              moment(
                                                flightInfo?.listFlight?.[1]
                                                  ?.listTrip?.[0]
                                                  ?.listItinerary?.[0]
                                                  ?.departureInfo?.datetime,
                                              ),
                                              translations,
                                            )}
                                          </>
                                        );
                                      })()}
                                  </>
                                ) : (
                                  // Hiển thị date của flight mặc định
                                  <>
                                    {formatDate(
                                      moment(
                                        flightInfo?.listFlight?.[0]
                                          ?.listTrip?.[0]?.listItinerary?.[0]
                                          ?.departureInfo?.datetime,
                                      ),
                                      translations,
                                    )}
                                    {flightInfo?.listFlight?.length > 1 && (
                                      <>
                                        {' - '}
                                        {formatDate(
                                          moment(
                                            flightInfo?.listFlight?.[1]
                                              ?.listTrip?.[0]
                                              ?.listItinerary?.[0]
                                              ?.departureInfo?.datetime,
                                          ),
                                          translations,
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </Typography>
                            </div>
                            <Button
                              className="btn-change-flight"
                              onClick={() => {
                                setFlightTargetItemId(
                                  dataHolidayList?.[0]?.id ?? null,
                                );
                                // Force remount FlightChange to reset its state
                                setFlightDrawerKey(prev => prev + 1);
                                // build params from current flightInfo so origin/dest are correct
                                const itinerary =
                                  flightInfo?.listFlight?.[0]?.listTrip?.[0]
                                    ?.listItinerary?.[0];
                                const returnItin =
                                  flightInfo?.listFlight?.[1]?.listTrip?.[0]
                                    ?.listItinerary?.[0];
                                const baseQuery =
                                  // flightDrawerSearch ||
                                  window.location.search || '';
                                const params = new URLSearchParams(baseQuery);
                                const stageUrl = params.get('stage');
                                if (itinerary) {
                                  const orig = itinerary.departureInfo?.code;
                                  const dest = itinerary.arrivalInfo?.code;
                                  const dt = itinerary.departureInfo?.datetime;
                                  if (orig) params.set('origin', orig);
                                  if (dest) params.set('destination', dest);
                                  if (dt) params.set('date', dt);
                                }
                                const isRoundTrip = stageUrl === 'round-trip';
                                if (
                                  isRoundTrip &&
                                  returnItin?.departureInfo?.datetime
                                ) {
                                  params.set(
                                    'returnDate',
                                    returnItin.departureInfo.datetime,
                                  );
                                } else {
                                  params.delete('returnDate');
                                }
                                setFlightDrawerSearch('?' + params.toString());
                                setFlightDrawerVisible(true);
                              }}
                            >
                              {translations?.['b2b.txt.changeFlight']}
                            </Button>
                          </div>
                          <Row
                            gutter={[16, 16]}
                            style={{ marginLeft: 10, marginRight: 10 }}
                            key={`flights-display-${flightRefreshKey}`}
                          >
                            <>
                              {displayFlights?.map((el, index) => {
                                const trip = el?.listTrip ? el.listTrip[0] : el;
                                const itinerary = trip?.listItinerary[0];

                                // Get selected flights from session storage to find the correct pricing
                                const savedFlights = getSelectedFlights();
                                // Find the selected pricing for this route
                                const savedFlight = savedFlights.find(
                                  sf => sf.route?.route === el.route,
                                );

                                // Use selected pricing if available, otherwise default to first pricing
                                let selectedPricing = trip?.listPricing?.[0];

                                if (savedFlight?.pricing) {
                                  // Find matching pricing by bookingClass
                                  const matchingPricing =
                                    trip?.listPricing?.find(
                                      (p: any) =>
                                        p.bookingClass ===
                                        savedFlight.pricing.bookingClass,
                                    );
                                  if (matchingPricing) {
                                    selectedPricing = matchingPricing;
                                  }
                                }

                                const cabinName =
                                  selectedPricing?.segmentFare?.[0]?.cabin
                                    ?.name || '';

                                return (
                                  <Col
                                    key={`flight-${el.route}-${index}`}
                                    span={
                                      flightInfo?.listFlight?.length === 1 ||
                                      isMobile
                                        ? 24
                                        : 12
                                    }
                                  >
                                    <div className="view-box-flight">
                                      <div className="boxHeaderFlight">
                                        <span className="text-title-info">
                                          {index === 0
                                            ? translations?.[
                                                'b2b.txt.departureLeg'
                                              ]
                                            : translations?.[
                                                'b2b.txt.returnLeg'
                                              ]}
                                        </span>{' '}
                                        <span>
                                          {formatDate(
                                            moment(itinerary.flightDate),
                                            translations,
                                          )}{' '}
                                          | {cabinName}
                                          <Tooltip
                                            color="white"
                                            overlayInnerStyle={{
                                              borderRadius: 12,
                                              maxWidth: 150,
                                              whiteSpace: 'normal',
                                              wordBreak: 'break-word',
                                              color: 'black',
                                            }}
                                            title={
                                              itinerary?.aircraftInfo?.name ??
                                              ''
                                            }
                                          >
                                            <InfoIcon
                                              style={{
                                                marginLeft: 5,
                                                cursor: 'pointer',
                                              }}
                                            />
                                          </Tooltip>
                                        </span>
                                      </div>
                                      <div
                                        className="d-flex"
                                        style={{ gap: 20 }}
                                      >
                                        <div className="text-time">
                                          {moment(
                                            itinerary?.departureInfo?.datetime,
                                          ).format('HH:mm')}
                                        </div>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ flex: 1 }}
                                        >
                                          <div className="dot" />
                                          <div className="line" />
                                          <div
                                            style={{
                                              position: 'relative',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <FlightIcon />
                                            <div
                                              style={{
                                                position: 'absolute',
                                                top: 15,
                                                fontSize: 12,
                                                color: '#8D8D8D',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                minWidth: 'max-content',
                                                alignItems: 'center',
                                              }}
                                            >
                                              {formatDuration(
                                                itinerary?.duration || '',
                                              )}
                                              <span>
                                                {translations?.[
                                                  'b2b.txt.directFlight'
                                                ] || ''}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="line" />
                                          <div className="dot-end" />
                                        </div>
                                        <div className="text-time">
                                          {moment(
                                            itinerary?.arrivalInfo?.datetime,
                                          ).format('HH:mm')}
                                        </div>
                                      </div>
                                      <div className="d-flex justify-content-between mt-1">
                                        <div>{el?.departure || ''}</div>
                                        <div>{el?.arrival || ''}</div>
                                      </div>
                                    </div>
                                  </Col>
                                );
                              })}
                            </>
                          </Row>
                        </>
                      )}
                    </div>
                    <div
                      className="d-flex justify-content-end"
                      hidden={isRefreshing || _.isEmpty(flightInfo?.listFlight)}
                    >
                      <ButtonPolicy onClick={onClickPolicy}>
                        {translations?.['b2b.txt.viewPurchaseRefundPolicy'] ||
                          ''}{' '}
                        <i
                          className="fa-solid fa-arrow-right"
                          style={{ fontSize: 12 }}
                        />
                      </ButtonPolicy>
                    </div>
                    <Title style={{ marginBottom: 6 }}>
                      {translations?.['b2b.txt.comboOptions']}
                    </Title>
                    <TitleNote>
                      {translations?.['b2b.txt.totalPricePerPassenger']}
                    </TitleNote>
                    {dataHolidayList?.length === 0 ? (
                      <NoDataComponent boxNoDataStyle={{ height: 'auto' }} />
                    ) : (
                      <>
                        {filterSearchRef.current?.comboType ===
                          COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET ||
                        filterSearchRef.current?.comboType ===
                          COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL ? (
                          <HolidayListFHT
                            onSelectCombo={onSelectComboFHT}
                            onSelectOtherPackage={onSelectOtherPackage}
                            data={dataHolidayList}
                            flightInfo={flightInfo}
                            comboType={filterSearchRef.current.comboType}
                          />
                        ) : (
                          <>
                            {dataHolidayList?.map(item => {
                              const displayCombo = getDisplayCombo(item);
                              const rowKey =
                                item.productCode || item.code || item.id;
                              const isDisableViewMore =
                                item.combo?.length === 1 ||
                                item.combo?.length === 0;

                              // Handler to navigate to PassengerInfo page

                              return (
                                <div key={rowKey} className="view-right-list">
                                  <div className="titleGroup">
                                    {item.productName}
                                  </div>
                                  {displayCombo && (
                                    <ItemCombo
                                      key={`${item.code}-${displayCombo.id}`}
                                      item={displayCombo}
                                      onClick={() =>
                                        handleComboSelect(displayCombo, item)
                                      }
                                    />
                                  )}

                                  <div className="d-flex justify-content-end mt-2">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        openDrawerWithCombos(
                                          item.combo,
                                          item.productName,
                                          item.price,
                                          item.id,
                                        )
                                      }
                                      style={{
                                        background: 'transparent',
                                        border: 'none',
                                        padding: 0,
                                        color: isDisableViewMore
                                          ? '#d9d9d9'
                                          : '#f06f24',
                                        fontWeight: 500,
                                        cursor: isDisableViewMore
                                          ? 'not-allowed'
                                          : 'pointer',
                                      }}
                                      disabled={isDisableViewMore}
                                    >
                                      {translations?.[
                                        'b2b.txt.viewMoreOptions'
                                      ] ??
                                        'Xem thêm các tuỳ chọn gói khác'}{' '}
                                      &gt;
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Col>
            </Row>
          </Col>

          <Drawer
            title={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div style={{ width: 40 }} />

                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    minWidth: 0,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {drawerTitle || ''}
                </div>

                <button
                  type="button"
                  onClick={() => setDrawerVisible(false)}
                  aria-label={translations?.['b2b.txt.close'] ?? 'Đóng'}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    padding: 8,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <CloseOutlined />
                </button>
              </div>
            }
            width={isMobile ? '100%' : 720}
            onClose={() => setDrawerVisible(false)}
            visible={drawerVisible}
            bodyStyle={{ padding: 0 }}
            closable={false}
            maskClosable={true}
            keyboard={false}
          >
            <div style={{ padding: '16px 24px' }}>
              <TicketList
                tickets={drawerTickets}
                loading={isLoadingConfirmPrice}
                onSelect={(ticket, siteCode, siteName, productCode) => {
                  handleTicketSelect(ticket, siteCode, siteName, productCode);
                }}
                siteCode={
                  dataHolidayList.find(
                    (item: any) => item.id === lastComboOpenedItemId,
                  )?.code || ''
                }
                siteName={drawerTitle}
                productCode={
                  dataHolidayList.find(
                    (item: any) => item.id === lastComboOpenedItemId,
                  )?.code || ''
                }
              />
            </div>
          </Drawer>

          <Drawer
            title={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    minWidth: 0,
                  }}
                >
                  {flightDrawerTitleNode || flightDrawerTitle}
                </div>

                <button
                  type="button"
                  onClick={() => setFlightDrawerVisible(false)}
                  aria-label={translations?.['b2b.txt.close'] ?? 'Đóng'}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    padding: 8,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <CloseOutlined />
                </button>
              </div>
            }
            width={device === 'desktop' ? 960 : '100%'}
            onClose={() => setFlightDrawerVisible(false)}
            visible={flightDrawerVisible}
            bodyStyle={{ padding: 0 }}
            closable={false}
            maskClosable={false}
          >
            <div>
              <FlightChange
                key={`flight-change-${flightDrawerKey}`}
                searchString={flightDrawerSearch}
                onComplete={selection => {
                  // Refresh selected flights from session storage
                  const savedFlights = getSelectedFlights();

                  if (savedFlights.length > 0) {
                    setSelectedFlight(savedFlights[0]);
                  }

                  // Force refresh display flights

                  setFlightRefreshKey(prev => prev + 1);

                  // Calculate price delta from selected flights
                  const outboundDelta =
                    selection?.outbound?.fare?.priceDelta ?? 0;
                  const returnDelta = selection?.return?.fare?.priceDelta ?? 0;
                  const totalDelta = outboundDelta + returnDelta;

                  // If user is doing an exchange (ticket change), update the exchange session
                  try {
                    const sessionJson = sessionStorage.getItem(
                      EXCHANGE_TICKETS_SELECTED,
                    );
                    if (sessionJson) {
                      const exchange = JSON.parse(sessionJson);
                      // Get passenger counts from saved search params or URL
                      const params = getSearchParams();
                      const adults = Number(params?.search?.adults ?? 1);
                      const children = Number(params?.search?.children ?? 0);
                      const paxCount = adults + children;

                      const addedAmount = Math.round(totalDelta * paxCount);

                      exchange.amountDiff =
                        (Number(exchange.amountDiff) || 0) + addedAmount;
                      exchange.selectedFlight = {
                        outbound: selection?.outbound ?? null,
                        return: selection?.return ?? null,
                        deltaPerPerson: totalDelta,
                        paxCount,
                      };

                      sessionStorage.setItem(
                        EXCHANGE_TICKETS_SELECTED,
                        JSON.stringify(exchange),
                      );
                    }
                  } catch (err) {
                    // ignore session update errors
                  }

                  const targetId =
                    flightTargetItemId ?? dataHolidayList[0]?.id ?? null;
                  if (targetId != null) {
                    setSelectedDeltas(prev => ({
                      ...prev,
                      [targetId]: totalDelta,
                    }));

                    // Update the dataHolidayList prices client-side to reflect selection
                    setDataHolidayList(prev =>
                      prev.map(d =>
                        d.id === targetId
                          ? { ...d, price: (d.price || 0) + totalDelta }
                          : d,
                      ),
                    );
                  }

                  // Show loading placeholder while we refresh holiday list
                  setIsRefreshing(true);

                  // Simulate a data reload and hide the placeholder when done
                  setTimeout(() => {
                    setIsRefreshing(false);
                    // Close drawer after refresh completes
                    setFlightDrawerVisible(false);
                  }, 800);
                }}
                inDrawer
                onHeaderReady={setFlightDrawerTitleNode}
              />

              {/* bottom sticky info when a delta is applied */}
              {Object.keys(selectedDeltas).length > 0 && (
                <div
                  style={{
                    position: 'fixed',
                    right: 24,
                    bottom: 24,
                    background: '#fff',
                    border: '1px solid #eee',
                    padding: '12px 16px',
                    borderRadius: 8,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                    zIndex: 1200,
                  }}
                >
                  <div style={{ fontWeight: 700 }}>
                    {`+${formatNumber(
                      Object.values(selectedDeltas).reduce((s, a) => s + a, 0),
                      '.',
                    )}đ`}
                  </div>
                  <div style={{ fontSize: 12, marginTop: 6 }}>
                    Giá vé thay đổi cho mỗi người
                  </div>
                  <div style={{ marginTop: 8, textAlign: 'right' }}>
                    <button
                      className="btn btn-link"
                      onClick={() => {
                        // Could open a detail modal — for now scroll to top
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }}
                    >
                      Xem chi tiết giá
                    </button>
                  </div>
                </div>
              )}
            </div>
          </Drawer>
          <DrawerOtherFHT
            visible={isDrawerOtherFHT}
            onCloseDrawer={onCloseDrawerOtherFHT}
            filter={filterChangeHotel}
            flightSummary={drawerFlightSummary}
            onSelectCombo={onSelectComboFromDrawer}
            isAllVisible={isAllVisible}
            loading={isLoadingConfirmPrice}
            comboType={filterSearchRef.current.comboType}
          />
        </HolidayListWrapper>
      </ContainerFluid>
    </LoadingContainer>
  );
};
const SliderWrapper = styled(Slider)`
  .ant-slider-rail {
    height: 6px;
    background-color: #e5e5e5;
  }
  .ant-slider-handle {
    border: 6px solid #f06f24 !important;
    height: 10px;
    width: 10px;
    box-sizing: content-box;
    margin-top: -9px;
  }
  .ant-slider-track {
    height: 6px;
    background-color: #f06f24 !important;
  }
  .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
    border-color: #f06f24 !important;
  }
  .ant-slider-handle:focus {
    box-shadow: 0 0 0 5px #f06f2433;
  }
`;
const Title = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: #000;
  margin-bottom: 20px;
`;
const TitleNote = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #000;
  margin-bottom: 20px;
`;
const ButtonPolicy = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--color-9);
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
